<template>
  <div class="orders-by-month-chart">
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'OrdersByMonthChart',
  props: {
    data: {
      type: Array,
      required: true,
    },
    showValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: this.categories,
        },
        yaxis: {
          title: {
            text: this.showValue ? 'Total Value ($)' : '# of Orders',
          },
          labels: {
            formatter: (value) => {
              if (this.showValue) {
                return '$' + (value / 1000).toFixed(0) + 'k'
              }
              return Math.round(value)
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
        },
        colors: ['#3c58e7', '#f54526'],
        tooltip: {
          y: {
            formatter: (val) => {
              if (this.showValue) {
                return '$' + val.toLocaleString()
              }
              return val + ' orders'
            },
          },
        },
      }
    },
    categories() {
      return _.map(this.data, (d) => {
        return moment()
          .year(d.year)
          .month(d.month - 1)
          .format('MMM YY')
      })
    },
    series() {
      const buildingData = _.map(this.data, (d) => {
        return this.showValue
          ? d.totalValue * (d.buildingOrders / d.count) || 0
          : d.buildingOrders || 0
      })
      const materialsData = _.map(this.data, (d) => {
        return this.showValue
          ? d.totalValue * (d.materialsOrders / d.count) || 0
          : d.materialsOrders || 0
      })

      return [
        {
          name: 'Building Orders',
          data: buildingData,
        },
        {
          name: 'Materials Orders',
          data: materialsData,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>



